import { translator } from 'core/localization/localization';

export const i18n = translator({
	'Add Rule': {
		no: 'Legg til regel',
	},
	'Add Group': {
		no: 'Legg til gruppe',
	},
});
